import { attrConfig as lineBreakTypeConfig } from './w-line-break-type.js';
import { attrConfig as clearTypeConfig } from './w-clear.js';

/** @type {import('@translator').AttrConfig[]} */
export default [lineBreakTypeConfig, clearTypeConfig];
